import './Header.css';
import {useEffect, useRef, useState} from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation} from 'swiper/modules';
import gsap from 'gsap';
import { Swiper as SwiperType } from 'swiper';
import {ArrowBarRight, VolumeMuteFill, VolumeOffFill, XLg} from "react-bootstrap-icons";
import useScreenWidth from "../../hooks/useScreenWidth";
import MyLoader from "../UI/MyLoader/MyLoader";

interface IModalContent {
    horizontalVideoUrl: string;
    title: string;
    description: string;
    videoUrl: string;
}

interface IMediaContent {
    id: number;
    imgUrl: string;
    videoUrl: string;
    horizontalVideoUrl: string;
    title: string;
    description: string;
}

const mediaContent: IMediaContent[] = [
    { id: 1, imgUrl: `${process.env.REACT_APP_IMG_URL}/headerImg/img1.jpeg`, videoUrl: `${process.env.REACT_APP_IMG_URL}/videos/1_morning_miartcom_vert.mp4`, horizontalVideoUrl: `${process.env.REACT_APP_IMG_URL}/horizontVideos/1_MORNONG_MIARTCOM_masterS.mp4`, title: 'Завтраки', description: '<b>Атмосферное</b><br/>Утро начинается здесь.<br /><br />Наши завтраки – это больше, чем просто еда - это моменты творчества и удовольствия. Попробуйте блюда, созданные с любовью, наслаждайтесь ароматным кофе и позвольте вдохновению наполнить ваш день.' },
    { id: 2, imgUrl: `${process.env.REACT_APP_IMG_URL}/headerImg/img2.jpeg`, videoUrl: `${process.env.REACT_APP_IMG_URL}/videos/2_flowers_miartcom_vert.mp4`, horizontalVideoUrl: `${process.env.REACT_APP_IMG_URL}/horizontVideos/2_FLOWERS_miartcomS.mp4`, title: 'Флористика', description: 'Каждая композиция — это маленькое произведение искусства.<br />Мы комбинируем свежие цветы, текстуры и идеи, чтобы создать что-то действительно уникальное и запоминающееся.<br />Украшения пространств под все времена года и проведения фотосесси для вашей семьи!' },
    { id: 3, imgUrl: `${process.env.REACT_APP_IMG_URL}/headerImg/img3.jpeg`, videoUrl: `${process.env.REACT_APP_IMG_URL}/videos/3_wedding_miarcom_vert.mp4`, horizontalVideoUrl: `${process.env.REACT_APP_IMG_URL}/horizontVideos/3_Wedding_MIARTCOM_masterS.mp4`, title: 'Праздник', description: 'Стильный интерьер, зонирование под ваши нужды, современное оборудование и творческая атмосфера делают наше арт-пространство идеальным выбором для вашего события. Мы предлагаем не только аренду помещения, но и помощь в организации вашего праздника: от декора до музыкального сопровождения.<br />Сделайте ваш день по-настоящему особенным!<br />Детали: в стоимость входит кухня с техникой, кулинарные шедевры, мастер классы.' },
    { id: 4, imgUrl: `${process.env.REACT_APP_IMG_URL}/headerImg/img4.jpeg`, videoUrl: `${process.env.REACT_APP_IMG_URL}/videos/4_lecture_miartcom_vert.mp4`, horizontalVideoUrl: `${process.env.REACT_APP_IMG_URL}/horizontVideos/4_LECTURE_MIARTCOM_masterS.mp4`, title: 'Лекции', description: 'Здесь рождаются инсайты и новые горизонты!<br /><br />Мы приглашаем талантливых лекторов и бизнес-тренеров, чтобы делиться с вами опытом, практическими инструментами и мотивацией для развития себя и своих идей.<br /><br />Наши лекции — это практики для тех, кто стремится к личному и профессиональному росту. Узнайте секреты успеха от известных бизнес-тренеров, вдохновляйтесь историями экспертов и применяйте знания на практике. Интерактивный формат, живое общение и только актуальные темы. Наши лекции — это место, где вы не только слушаете, но и находите единомышленников, задаёте вопросы и получаете ценные ответы.' },
    { id: 5, imgUrl: `${process.env.REACT_APP_IMG_URL}/headerImg/img5.jpeg`, videoUrl: `${process.env.REACT_APP_IMG_URL}/videos/5_bowls_miartcom_vert.mp4`, horizontalVideoUrl: `${process.env.REACT_APP_IMG_URL}/horizontVideos/5_BOWLS_MIARTCOM_masterS.mp4`, title: 'Духовные практики', description: 'Сохранение ментального здоровья — это искусство.<br /><br />Мы предлагаем практики, которые исцеляют и вдохновляют: медитации под звуки гонга, терапия с поющими чашами и техники работы со страхами.<br /><br />Каждая практика — это особое путешествие к самому себе.<br />Мы используем древние техники и современные подходы, чтобы вы чувствовали себя обновлённым и наполненным энергией.' },
    { id: 6, imgUrl: `${process.env.REACT_APP_IMG_URL}/headerImg/img6.jpeg`, videoUrl: `${process.env.REACT_APP_IMG_URL}/videos/6_yoga_miartcom_vert.mp4`, horizontalVideoUrl: `${process.env.REACT_APP_IMG_URL}/horizontVideos/6_YOGA_MIARTCOM_master.mp4`, title: 'Здоровье', description: 'Здоровье — это баланс тела, разума и души.<br /><br />Мы предлагаем практики, которые укрепляют физическое здоровье, помогают справляться со стрессом и открывают новые уровни осознанности.<br /><br />Наши занятия — это не просто тренировки. Мы делимся знаниями о физиологии и влиянии практик на тело и разум, чтобы вы могли осознанно заботиться о своём здоровье.' },
    { id: 7, imgUrl: `${process.env.REACT_APP_IMG_URL}/headerImg/img7.jpeg`, videoUrl: `${process.env.REACT_APP_IMG_URL}/videos/7_dinner_miartcom_vert.mp4`, horizontalVideoUrl: `${process.env.REACT_APP_IMG_URL}/horizontVideos/7_DINNER_MIARTCOM_master.mp4`, title: 'Гастроужин', description: 'Гастроужины в нашем арт-пространстве<br />— это уютные вечера с домашними блюдами, приготовленными хозяйкой пространства. Закрытый формат, лучшие рецепты и душевная атмосфера превращают каждый ужин в маленький праздник.' },
];

const Header: React.FC = () => {
    const [currentTitle, setCurrentTitle] = useState(mediaContent[0].title);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isAnimating, setIsAnimating] = useState(true);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [modalContent, setModalContent] = useState<IModalContent | null>(null);
    const [isVideoLoading, setIsVideoLoading] = useState(true);
    const screenWidth = useScreenWidth();
    const isDesktop = screenWidth > 1000;
    const itemSize = screenWidth / mediaContent.length;
    const refs = useRef<(HTMLDivElement | null)[]>([]);
    const [isModalDescVisible, setModalDescVisible] = useState<boolean>(true);
    const [currentImgIdx, setCurrentImgIdx] = useState<null | number>(null);
    const modalOverlayRef = useRef<HTMLDivElement | null>(null);
    const [isVideoSound, setIsVideoSound] = useState<boolean>(true);
    const startX = useRef<number | null>(null);
    const endX = useRef<number | null>(null);

    const handleVideoSound = () => {
        setIsVideoSound((prev) => {
            const newSoundState = !prev;
            const video = document.querySelector('.modal-video') as HTMLVideoElement;

            if (video) {
                video.muted = !newSoundState;
                video.volume = newSoundState ? 1.0 : 0;
            }

            return newSoundState;
        });
    };

    const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
        startX.current = e.touches[0].clientX;
        endX.current = null;
    };

    const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
        endX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = () => {
        if (startX.current !== null && endX.current !== null) {
            const swipeDistance = endX.current - startX.current;

            if (swipeDistance > 50) {
                setModalDescVisible(false);
            }
        }

        startX.current = null;
        endX.current = null;
    };

    const handleTouchEndOnModal = () => {
        if (startX.current !== null && endX.current !== null) {
            const swipeDistance = endX.current - startX.current;

            if (swipeDistance > 50) {
                closeModal();
            }
        }

        startX.current = null;
        endX.current = null;
    };

    useEffect(() => {
        if (!isDesktop) {
            setIsAnimating(false);
            return;
        } else {
            setIsAnimating(true);
        }

        const galleryItems = document.querySelectorAll<HTMLElement>('.swiper-slide');

        gsap.fromTo(
            galleryItems[3],
            { autoAlpha: 0, x: 0 },
            {
                duration: 1,
                autoAlpha: 1,
                x: 0,
                ease: 'power2.out',
                delay: 0.4,
                onComplete: () => {
                    setTimeout(() => {
                        handleAnimationComplete()
                    }, 800);
                }
            }
        );

        for (let i = 2; i >= 0; i--) {
            gsap.fromTo(
                galleryItems[i],
                { autoAlpha: 0, x: '-100%' },
                {
                    duration: 1,
                    autoAlpha: 1,
                    x: 0,
                    ease: 'power2.out',
                    delay: 0.5 + 0.2 * (3 - i),
                    onComplete: () => {
                        setTimeout(() => {
                            handleAnimationComplete()
                        }, 800);
                    }
                }
            );
        }

        for (let i = 4; i < galleryItems.length; i++) {
            gsap.fromTo(
                galleryItems[i],
                { autoAlpha: 0, x: '100%' },
                {
                    duration: 1,
                    autoAlpha: 1,
                    x: 0,
                    ease: 'power2.out',
                    delay: 0.5 + 0.2 * (i - 4),
                    onComplete: () => {
                        setTimeout(() => {
                            handleAnimationComplete()
                        }, 800);
                    }
                }
            );
        }

        const handleAnimationComplete = () => {
            setIsAnimating(false);
        };

        galleryItems.forEach((element, index) => {
            const video = element.querySelector('video') as HTMLVideoElement;

            element.addEventListener('mouseenter', () => {
                if (video) {
                    video.play().catch(console.error); 
                }
            });

            element.addEventListener('mouseleave', () => {
                if (video) {
                    video.pause();
                }
            });
        });
    }, []);

    useEffect(() => {
        const countItemSize = () => {
            if (isDesktop) {
                return screenWidth / mediaContent.length;
            } else {
                return screenWidth / 1.9
            }
        }

        let galleryItems: NodeListOf<HTMLElement> = document.querySelectorAll<HTMLElement>('.swiper-slide');
        let swiperWrapper: Element | null = document.querySelector('.swiper-wrapper');
        let screenWidth: number = window.innerWidth;
        let itemSize: number = countItemSize();
        let activeItemSize: number = isDesktop ? (itemSize * 1.5) - 10 : itemSize;

        galleryItems.forEach((element: HTMLElement) => {
            gsap.to(element, { width: itemSize, duration: 0.7, ease: 'power2.in' });
            element.style.width = `${itemSize}px`;
        });

        if (window.innerWidth > 768 && !isAnimating) {
            const handlers: { element: Element; onMouseEnter: () => void; onMouseLeave: () => void }[] = [];

            galleryItems.forEach((element: HTMLElement, index: number) => {
                const onMouseEnter = () => {
                    gsap.to(element, { width: activeItemSize, duration: 0.7, ease: 'power2.out' });
                    gsap.to(swiperWrapper, { duration: 0.7, ease: 'power2.out' });
                    setCurrentTitle(mediaContent[index].title);
                    animateText(mediaContent[index].title);
                };

                const onMouseLeave = () => {
                    gsap.to(element, { width: itemSize, duration: 0.7, ease: 'power2.in' });
                    gsap.to(swiperWrapper, { duration: 0.7, ease: 'power2.in' });
                };

                element.addEventListener('mouseenter', onMouseEnter);
                element.addEventListener('mouseleave', onMouseLeave);
                handlers.push({ element, onMouseEnter, onMouseLeave });
            });

            return () => {
                handlers.forEach(({ element, onMouseEnter, onMouseLeave }) => {
                    element.removeEventListener('mouseenter', onMouseEnter);
                    element.removeEventListener('mouseleave', onMouseLeave);
                });
            };
        }
    }, [isAnimating, screenWidth]);

    useEffect(() => {
        animateText(isDesktop ? currentTitle : mediaContent[currentIndex].title);
    }, [currentTitle, currentIndex]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        const index = refs.current.indexOf(entry.target as HTMLDivElement);
                        if (index !== -1) {
                            setCurrentIndex(index);
                            setCurrentTitle(mediaContent[index].title);
                        }
                    }
                });
            },
            {
                root: null,
                rootMargin: '0px',
                threshold: 0.8,
            }
        );

        refs.current.forEach((ref) => {
            if (ref) observer.observe(ref);
        });

        return () => {
            refs.current.forEach((ref) => {
                if (ref) observer.unobserve(ref);
            });
        };
    }, []);

    const openModal = (horizontalVideoUrl: string, title: string, description: string, videoUrl: string) => {
        setModalContent({ horizontalVideoUrl, title, description, videoUrl });
        setIsModalOpen(!isModalOpen);
    };

    const closeModal = () => {
        if (modalOverlayRef.current) {
            modalOverlayRef.current.style.transform = 'translateX(100%)';
            modalOverlayRef.current.style.opacity = '0';

            const handleTransitionEnd = () => {
                setIsModalOpen(false);
                setModalContent(null);
                setIsVideoLoading(true);
                setCurrentImgIdx(null);

                modalOverlayRef.current?.removeEventListener('transitionend', handleTransitionEnd);
            };

            modalOverlayRef.current.addEventListener('transitionend', handleTransitionEnd);
        }
    };

    const closeDescription = () => {
        setModalDescVisible(false);
    };

    const animateText = (title: string) => {
        const titleElement = document.querySelector('.main_header_subtitle h3');

        if (titleElement) {
            const titleLetters = title.split('').map(letter => `<span>${letter}</span>`).join('');

            titleElement.innerHTML = titleLetters;

            gsap.fromTo(
                titleElement.querySelectorAll('span'),
                { y: -50, opacity: 0 },
                {
                    y: 0,
                    opacity: 1,
                    duration: 0.5,
                    stagger: {
                        amount: 0.5,
                        from: 'random',
                    },
                    ease: 'back.out(1.7)',
                }
            );
        }
    };

    return (
        <div
            className={`home-grid-wrapper ${isAnimating ? 'no-interactions' : ''}`}
            style={{ pointerEvents: isAnimating ? 'none' : 'auto' }}
        >
            <div className={`inner-wrapper ${isModalOpen ? 'open' : ''}`}>
                <Swiper
                    modules={[Navigation]}
                    spaceBetween={20}
                    breakpoints={{
                        0: {
                            allowTouchMove: false,
                            slidesPerView: 0,
                        }
                    }}
                    navigation
                    observer
                    observeParents
                    onSlideChange={(swiper: SwiperType) => setCurrentIndex(swiper.activeIndex)}
                >
                    {mediaContent.map((img, index): React.JSX.Element => (
                        <SwiperSlide key={index} className={`swiper-slide ${currentImgIdx === img.id ? 'open' : ''}`} style={{minWidth: `${itemSize}px}`}}>
                            <div
                                className={`media-wrapper ${isDesktop ? 'desktop' : ''}`}
                                ref={(el) => (refs.current[index] = el)}
                                onClick={(e) => {
                                    setModalDescVisible(true);
                                    setCurrentImgIdx(index + 1);
                                    setIsVideoSound(true);

                                    if (!isDesktop) {
                                        const img = e.currentTarget.querySelector('img') as HTMLImageElement;

                                        if (img) {
                                            openModal(img.src, mediaContent[index].title, mediaContent[index].description, mediaContent[index].videoUrl);
                                        }
                                    } else {
                                        const videoSrc = mediaContent[index].horizontalVideoUrl;
                                        openModal(videoSrc, mediaContent[index].title, mediaContent[index].description, mediaContent[index].videoUrl);
                                    }
                                }}
                            >
                                <img
                                    className="slide-image"
                                    src={img.imgUrl}
                                    alt={`headerImg${index + 1}`}
                                />

                                {isDesktop && (
                                    <video
                                        className="slide-video"
                                        src={img.videoUrl}
                                        muted
                                        loop
                                    />
                                )}
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>

            <div className='main_header_subtitle'>
                <h3>{currentTitle}</h3>
            </div>

            {(isModalOpen && modalContent) && (
                <div className={`modal-overlay  ${!isModalOpen ? 'clouse' : ''}`} onClick={closeModal} ref={modalOverlayRef}>
                    <div className="modal-content" onClick={(e) => e.stopPropagation()}
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEndOnModal}
                    >
                        <video
                            src={ isDesktop ? modalContent.horizontalVideoUrl : modalContent.videoUrl }
                            autoPlay={true}
                            className="modal-video"
                            playsInline
                            loop
                            defaultValue={0.5}
                            onLoadedData={() => setIsVideoLoading(false)}
                            onError={() => setIsVideoLoading(false)}
                        />

                        {(isVideoLoading) && (
                            <div className='modal-content-loader'>
                                <MyLoader color='#754737FF'/>
                            </div>
                        )}

                        <div className={`modal-description ${screenWidth > 1300 ? '' : 'mobile'} ${!isVideoLoading && isModalDescVisible ? 'visible' : ''}`}
                            onTouchStart={handleTouchStart}
                            onTouchMove={handleTouchMove}
                            onTouchEnd={handleTouchEnd}
                        >
                            <h3>{modalContent.title}</h3>

                            <p dangerouslySetInnerHTML={{__html: modalContent.description}} />


                            <ArrowBarRight className='modal-overlay-clouse-description' onClick={closeDescription} />
                        </div>

                        {isVideoSound ? (
                            <VolumeOffFill className={`volumeIcon ${screenWidth <= 1000 ? 'mobile' : ''}`} onClick={handleVideoSound} size={35} />
                        ) : (
                            <VolumeMuteFill className={`volumeIcon ${screenWidth <= 1000 ? 'mobile' : ''}`} onClick={handleVideoSound} size={35} />
                        )}

                        {isDesktop ? (
                                <div className='modal-overlay-clouse-wrap' onClick={closeModal}>
                                    <XLg className='modal-overlay-clouse' />
                                </div>
                        ) : (
                            <div className='modal-overlay-clouse-wrap mobile'>
                                <ArrowBarRight className='modal-overlay-clouse' onClick={closeModal} />
                            </div>
                        )}
                    </div>
                </div>
                )}
        </div>
    );
};

export default Header;